import { ReactNode } from "react"
import { classNames } from "../../../utils/classNames"

interface SplitViewProps {
  children: ReactNode
  className?: string
}

export const SplitView = ({ children, className }: SplitViewProps) => {
  return (
    <div
      className={classNames(
        "flex min-h-0 w-full flex-1 flex-col overflow-hidden",
        className,
      )}
    >
      <div className="flex min-h-0 flex-1 overflow-hidden">{children}</div>
    </div>
  )
}

interface SplitViewSectionProps {
  children: ReactNode
  className?: string
  /**
   * Tailwind width class. Defaults to "w-1/2".
   */
  width?: string
}

export const SplitViewSection = ({
  children,
  className,
  width = "w-1/2",
}: SplitViewSectionProps) => {
  return (
    <div
      className={classNames("h-full min-h-0 overflow-hidden", width, className)}
    >
      {children}
    </div>
  )
}
